export default __webpack_public_path__ + "static/media/selectedIcon.44e5180f.svg";